import * as React from 'react';
import { useState, useEffect } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { Button, Form, Input, Space, Tabs, Spin, TabsProps, Table, Typography } from 'antd';
import { Box, CircularProgress, Stack } from '@mui/material';
import { UserOutlined, ContainerFilled, FileTextOutlined } from '@ant-design/icons';
import InputForm from './InputT';
import { ColumnsType } from 'antd/es/table';
import axios from 'axios';
import ParamsPicklist from '../Types/ParamsPicklist';
import DataType from '../Types/DataTablePiclist';
import Datas from "../Data/Data.json"
import { Crypter } from '../Functions/Security/Crypter';
import { useAuthHeader } from '../Services/Auth/sessionAuth';
import SweetAlert from 'sweetalert2';
import "../Styles/StyleHome.css";

//let LinkSourceApi= require('../../Data/Data.json');

//structure de parametre d'api de recherche
/*interface Params{
  CodeAgence?:string,
  Table:string,
  Colonne1:string,
  Colonne2:string,
  Colagence?:string,
  choix:number
 }
 */

export interface ConfirmationDialogRawProps {
  id: string;
  keepMounted: boolean;
  value: string;
  onClose: (value?: string) => void;
}

const SearchModal = (props: { Titre: string, label: string, name: string, data?: any, Taille1?: number | string , Taille2?: number | string, Parametre?: ParamsPicklist, form?: any, notRequired?: true, defaultCode?: string, defaultLibelle?: string, width?: number | string, disabled?: boolean, handleFunction?: any, ExecuteafterSelect1?: any, ExecuteafterSelect2?: any, notremove?: true, title?: string }) => {

  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [Libelle, SetLibelle] = React.useState(props.defaultLibelle);
  const [Code, SetCode] = React.useState(props.defaultCode);
  const [Data, SetData] = React.useState<DataType[]>(props.data);
  const [searchLoading, setSearchLoading] = React.useState(false);
  let notR = props.notRequired ? false : true
  const [pageIsLoad, setPageIsLoad] = React.useState(true);
  const [SearchR, SetSearchR] = React.useState<string>("");
  const [Load, SetLoad] = useState(false);

  useEffect(() => {
    if (Load === false) {
      SetData([]);
      SetSearchR("");
      SetLoad(true);
    }
  }, [])



  const columns: ColumnsType<DataType> = [
    {
      title: 'Code',
      dataIndex: 'Code',
    },
    {
      title: 'Libelle',
      dataIndex: 'Libelle',
      filteredValue: [SearchR],
      onFilter: (value: any, record: any) => {
        return String(record.Code)
          .toLowerCase()
          .includes(value.toLowerCase()) ||
          String(record.Libelle)
            .toLowerCase()
            .includes(value.toLowerCase())
      },
    }];

 useEffect(() => {
    if(props.defaultCode !== undefined && props.defaultCode !== ''){
      SetCode(props.defaultCode);
      SetLibelle(props.defaultLibelle ?? '');
      props.form.setFieldValue(props.name, props.defaultCode);
      props.form.setFieldValue("lib_" + props.name, props.defaultLibelle ?? '');
    } else {
      SetCode('');
      SetLibelle('');
      props.form.setFieldValue(props.name, '');
      props.form.setFieldValue("lib_" + props.name, '');
    }

    }, [
    props.defaultCode,
    props.defaultLibelle
    ]);


  // USER TOKEN
  const authHeader = useAuthHeader()

  const handleClickOpen = () => {
    setSelectedRowKeys([])
    if (props.data) SetData(props.data);
    setOpen(true);
  };

  const handleClose = (o: number) => {
    if (o == 0) {
      setOpen(false);

      SetSearchR("");
    }
    else {
    }
  };

  //CodeAgence:'',Table: "TITRES",Colonne1:"CDTITR",Colonne2:"LIBELL1",Colagence:'101',Init:values.text,choix:22

  const onFinis = async (values: any) => {
 
    setLoading(true);
    const datat: DataType[] = [];
 
    var data = { CodeAgence: props.Parametre?.CodeAgence, Table: props.Parametre?.Table, Colonne1: props.Parametre?.Colonne1, Colonne2: props.Parametre?.Colonne2, Colagence: props.Parametre?.Colagence, Init: values.text, choix: props.Parametre?.Choix, colfiltre: props.Parametre?.colfiltre, valfiltre: props.Parametre?.valfiltre }
    //console.log(Crypter.encrypt(JSON.stringify(data)))
    //alert(props.Parametre?.CodeAgence+''+props.Parametre?.Table+props.Parametre?.Colonne1+props.Parametre?.Colonne2+props.Parametre?.Colagence+values.text+props.Parametre?.Choix+props.Parametre?.colfiltre+props.Parametre?.valfiltre)
    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(data))
      }
    };
    await
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
         // console.log(res)
            if (res.StatutCode == 200) {
              let datas = res.Result.Table;

              if (datas.length === 0) {
                //console.log("aucun élément ");
                SetData(datat)
              }
              else {
                datas.map((data: any, indice: number) => {
                  const codeKey = props.Parametre?.Colonne1 ?? Object.keys(data)[0];
                  const libelleKey = props.Parametre?.Colonne2 ?? Object.keys(data)[1];
                  datat.push({
                    key: indice,
                    Code: data[codeKey] ?? data[Object.keys(data)[0]],
                    Libelle: data[libelleKey] ?? data[Object.keys(data)[1]],
                  });
                  //alert(datat)
                  SetData(datat);
                })
                // for(let i=0;i<=datas.length;i++)
                // {
                //   datat.push({
                //     key: i,
                //     Code: datas[i][1],
                //     Libelle: datas[i][0],
                //   });
                //   SetData(datat);  
                // }
              }
            }
          }
          setLoading(false);

        }).catch((error) => {
          console.log(error)
          setLoading(false);
          SweetAlert.fire({ title: "Error", text: error.message,icon: "error"  })
        })


  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <Typography><UserOutlined />IDENTIFIANT</Typography>
        </span>
      ),
      children: <InputForm notRequired name='text' type='text' label='IDENTIFIANT' />,
    },
    {
      key: '2',
      label: (
        <span id='Tab'>
          <Typography><FileTextOutlined />LIBELLE</Typography>
        </span>
      ),

      children: <InputForm disabled={props.disabled} notRequired name='text' type='text' label='LIBELLE' />,
    },
    {
      key: '3',
      label: (
        <span id='Tab'>
          <Typography><ContainerFilled />ALL</Typography>
        </span>
      ),
      children: <Box fontStyle={'inherit'} display={'flex'}><InputForm noupercase taille={600} autoFocus disabled={props.disabled} onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} notRequired name='text' type='text' label='TEXT' /><hr /> <Button onClick={onFinis} style={{ top: "10px" }}>Rechercher</Button></Box>,
    },
  ];


  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: any) => {
    const selectedIndex = Array.isArray(newSelectedRowKeys) ? newSelectedRowKeys[0] : newSelectedRowKeys;
    const selected = Data[Number(selectedIndex)];
    if (!selected) return;

    setSelectedRowKeys(Array.isArray(newSelectedRowKeys) ? newSelectedRowKeys : [newSelectedRowKeys]);
    SetLibelle(String(selected.Libelle ?? ''));
    SetCode(String(selected.Code ?? ''));
    props.form.setFieldValue(props.name, selected.Code);
    props.form.setFieldValue("lib_" + props.name, selected.Libelle);

    if (props.handleFunction) {
      props.handleFunction(String(selected.Code ?? ''), String(selected.Libelle ?? ''));
    }

    setTimeout(() => {
      setOpen(false); SetData([]);
      props.form.setFieldValue('text', '');
    }, 250);

    if (props.ExecuteafterSelect1) {
      props.ExecuteafterSelect1();
    }
    if (props.ExecuteafterSelect2) {
      props.ExecuteafterSelect2();
    }

  };



  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  function handleReset() {
    //console.log(props.name)
    props.form.setFieldValue(props.name, "")
    props.form.setFieldValue("lib_" + props.name, "")
    //props.form.resetFields()
  };
  // const hasSelected = selectedRowKeys.length > 0;

  function handleSearch(e: any) {
 
    if ((e.key == 'Tab'  || e.key == undefined && e.target.value !='')) { // && e.target.value != ""
      
      setSearchLoading(true)
      setLoading(true);
      const datat: DataType[] = [];
      
      var data = { CodeAgence: props.Parametre?.CodeAgence, Table: props.Parametre?.Table, Colonne1: props.Parametre?.Colonne2, Colonne2: props.Parametre?.Colonne1, Colagence: props.Parametre?.Colagence, Init: e.target.value, choix: 1, colfiltre: props.Parametre?.colfiltre, valfiltre: props.Parametre?.valfiltre }
     
      //console.log(Crypter.encrypt(JSON.stringify(data)))
     
      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.AnySearch,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(data))
        }
      };
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            //console.log(res)
            if (res.StatutCode == 200) {
              let datas = res.Result.Table;
             // console.log(datas);

              if (datas.length === 0) {
                //console.log("aucun élément ");
                SetData(datat)

                if (!props.notremove) {
                  SetCode("")
                  SetLibelle("")
                  props.form.setFieldValue(props.name, "")
                  props.form.setFieldValue("lib_" + props.name, "")
                  handleReset()
                }

              }
              else if (datas.length === 1) {
               
                datas.map((data: any, indice: number) => {
                  const codeKey = props.Parametre?.Colonne1 ?? Object.keys(data)[0];
                  const libelleKey = props.Parametre?.Colonne2 ?? Object.keys(data)[1];
                  datat.push({
                    key: indice,
                    Code: data[codeKey] ?? data[Object.keys(data)[0]],
                    Libelle: data[libelleKey] ?? data[Object.keys(data)[1]],
                  });
                })

                SetData(datat);
                SetCode(datat[0].Code)
                SetLibelle(datat[0].Libelle)
                props.form.setFieldValue(props.name, datat[0].Code)
                props.form.setFieldValue("lib_" + props.name, datat[0].Libelle)

                if (props.handleFunction) {
                  props.handleFunction(props.form.getFieldValue(props.name));
                }

                if (props.ExecuteafterSelect1) {
                  props.ExecuteafterSelect1();
                }
                if (props.ExecuteafterSelect2) {
                  props.ExecuteafterSelect2();
                }
              }
              else {
                if (!props.notremove) {
                 
                  SetCode("")
                  SetLibelle("")
                  props.form.setFieldValue(props.name, "")
                  props.form.setFieldValue("lib_" + props.name, "")
                  handleReset()
                }

                if (props.handleFunction) {
                   
                  props.handleFunction("");
                }
              }
            }
            else {
              if (!props.notremove) {
                SetCode("")
                SetLibelle("")
                handleReset()
              }

              //  if(!props.notresponse){
              //   SweetAlert.fire({ title: "Error", text: res.Message, icon: "error" })
              // }

              if (props.handleFunction) {
                props.handleFunction("");
              }
            }
          }
          setLoading(false);
          setSearchLoading(false)

        }).catch((error) => {
          SetCode("")
          SetLibelle("")
          props.form.setFieldValue(props.name, "")
          props.form.setFieldValue("lib_" + props.name, "")
          setSearchLoading(false)
          console.log(error)
          setLoading(false);
          SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
          if (props.handleFunction) {
            props.handleFunction("");
          }
        })

      SetData([]);
      props.form.setFieldValue('text', '');
    }
  }

  function handleChange(e: any) {
    const value = e.target.value;
    SetCode(value);
    props.form.setFieldValue(props.name, value);
  }

  return (
  <div className='bordure2'>
  <Form.Item
    label={props.label || undefined}
    required={notR}
    colon={false}
    labelCol={props.label ? {
      span: props.width,
      style: {
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word', // Permet le retour à la ligne
        wordBreak: 'keep-all',      // Interdit de couper les mots au milieu
      }
    } : undefined}
  >
    <Space.Compact block>
        <Form.Item
            noStyle
            preserve
            name={props.name}
            rules={[
                {
                    required: notR,
                    message:
                        `${props.label} obligatoire`
                }
            ]}
        >
            <Input.Search
                title={props.title}
                disabled={props.disabled}
                onChange={handleChange}
                onBlur={handleSearch}
                onKeyDown={handleSearch}
                onSearch={handleClickOpen}
                style={{
                    width:
                    props.Taille1==="100%"
                    ?"30%"
                    :props.Taille1
                }}
            />
        </Form.Item>

        <Form.Item
            noStyle
            preserve
            name={"lib_"+props.name}
        >
            <Input
                title={props.title}
                disabled
                style={{
                    width:
                    props.Taille2==="100%"
                    ?"70%"
                    :props.Taille2
                }}
            />
        </Form.Item>

    </Space.Compact>

</Form.Item>

      <Dialog
        className='modal'
        onClick={() => { handleClose(1) }}
        sx={{ '& .MuiDialog-paper': { minWidth: 'sm', maxHeight: 'md' } }} maxWidth='md' open={open} onClose={() => { handleClose(0) }} >
        <DialogTitle>{props.Titre}</DialogTitle>
        <DialogContent dividers></DialogContent>
        <Spin spinning={loading} tip="En Cour de Traitement ..." style={{ color: 'green' }} >
          <Stack direction='row' spacing={5}>
            <Form name="basi" wrapperCol={{ span: 16 }} style={{ minWidth: 600, marginLeft: 50 }} initialValues={{ remember: true }} onFinish={onFinis} onFinishFailed={onFinishFailed}  >
              <Tabs defaultActiveKey="3" items={items} />
            </Form>
          </Stack>
          <DialogContent dividers>
            <Table style={{ width: 'auto' }} rowSelection={{ ...rowSelection, type: "radio", getCheckboxProps: (reccord) => ({ disabled: props.disabled }) }} scroll={{ y: 250, x: 10 }} columns={columns} dataSource={Data} />
          </DialogContent>
        </Spin>
        <DialogActions>
          <Button type='default' disabled={props.disabled} color='red' onClick={() => { SetData([]); props.form.setFieldValue('SetSearchR', ""); SetSearchR(""); handleClose(0); }}>Fermer</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SearchModal;